module.exports = __webpack_public_path__ + "static/media/OrderSummaryLinkScreen.1df92303.png";